export default "__VITE_ASSET__8DZCbMKJ__"